module.exports = __webpack_public_path__ + "img/pending-analysis.e3cd5e0c.png";